import React from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import ContactsPage from "../../../Contacts/ContactsPage";
import ContactSets from "../../../Contacts/ContactSets";
import AddContact from "../../../Contacts/AddContact";
import AddBulk from "../../../Contacts/AddBulk";
import ContactFields from "../../../Contacts/ContactFields";
import {
  closeModal,
  selectCurrentModal,
  selectModalTab,
  setModalTab,
} from "../../../store/slices/modalsSlice";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";

export default function ContactsModal() {
  const dispatch = useDispatch();
  const show = useSelector(selectCurrentModal) === "contacts";
  const tab = useSelector(selectModalTab);
  const setTab = (t) => dispatch(setModalTab(t));
  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      size="xl"
      show={show}
      onHide={handleClose}
      scrollable
      fullscreen="xxl-down"
      className="contacts-modal"
      backdropClassName="contacts-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="icon fa fa-edit" />
          <FontAwesomeIcon icon={faUserPlus} /> Contacts{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs
          id="uncontrolled-tab-contacts"
          className="mb-3"
          unmountOnExit
          activeKey={tab}
          onSelect={(key) => {
            setTab(key);
          }}
        >
          <Tab eventKey="contacts" title="Contacts">
            <div className="row align-items-stretch" style={{ minHeight: 400 }}>
              <ContactsPage isModal />
            </div>
          </Tab>
          <Tab eventKey="contact-sets" title="Groups">
            <div className="row align-items-stretch" style={{ minHeight: 400 }}>
              <div className="col d-flex flex-column">
                <ContactSets isModal />
              </div>
            </div>
          </Tab>
          <Tab eventKey="add-contact" title="Add contact">
            <div className="row align-items-stretch" style={{ minHeight: 400 }}>
              <div className="col d-flex flex-column">
                <AddContact
                  editedContact={{
                    status: "active",
                    details: [],
                  }}
                />
              </div>
            </div>
          </Tab>
          <Tab eventKey="contact" title="Bulk add">
            <AddBulk />
          </Tab>
          <Tab eventKey="fields" title="Manage fields">
            <div className="row align-items-stretch" style={{ minHeight: 400 }}>
              <div className="col d-flex flex-column">
                <ContactFields />
              </div>
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
}
